import { render, staticRenderFns } from "./SingleNotification.vue?vue&type=template&id=9c3d136c&scoped=true&"
import script from "./SingleNotification.vue?vue&type=script&lang=js&"
export * from "./SingleNotification.vue?vue&type=script&lang=js&"
import style0 from "./SingleNotification.vue?vue&type=style&index=0&id=9c3d136c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3d136c",
  null
  
)

export default component.exports